export default "__VITE_ASSET__CN12Oz3$__"